module.exports = __webpack_public_path__ + "img/triangle.b342a600.svg";